import { createFileRoute } from '@tanstack/react-router';
import { OrderDetailPage } from '@/pages/OrderManagement/OrderDetail';

export const Route = createFileRoute('/_admin/order-management/$orderId')({
  component: OrderDetailPage,
  validateSearch: (search: Record<string, unknown>) => ({
    action: search.action as string | undefined,
    tab:    search.tab as string | undefined,
  }),
});
